















import { ButtonType, IconSize, ParagraphSize, wave } from '@getaccept/lib-ui';
import { defineComponent } from '@vue/composition-api';
import { t } from '../../helpers/translation.helper';

export default defineComponent({
  name: 'MarkAllAsReadButton',
  directives: {
    wave,
  },
  props: {
    unreadCount: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return { ButtonType, IconSize, ParagraphSize, t };
  },
});
